import React, { useState } from "react";
import { Colors } from "../../Constants/colors";
import { ParentsListModal } from "../parents/ParentsListModal";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedParents } from "../../Redux/Slices/studentAdmission.slice";
import { RootState } from "../../Redux/store";
import { SelectedParents } from "../parents/SelectedParents";
import userGroup from "./../../images/users-icon.svg";
import { Link } from "react-router-dom";
import { Paths } from "../../Constants/paths";

const StudentAdmissionFormStepOne = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const { selectedParents } = useSelector((state: RootState) => ({
    selectedParents: state.studentAdmission.selectedParents,
  }));

  return (
    <div
      className="flex flex-col justify-center items-center"
      style={{
        minHeight: "200px",
      }}
    >
      {!selectedParents ? (
        <div className="mt-2 flex flex-col items-center">
          <div
            className="w-full mb-4"
            style={{
              maxWidth: "50px",
              maxHeight: "50px",
            }}
          >
            <img src={userGroup} alt="user-group" />
          </div>

          <div
            className="w-full text-center text-base font-medium"
            style={{ color: Colors.Grey }}
          >
            You need to select the parents of the student before filling up the
            admission form.
          </div>
          <div
            className="w-full text-center text-sm mt-1"
            style={{
              color: Colors.Grey,
              maxWidth: "450px",
            }}
          >
            <span
              className="underline"
              style={{ color: Colors.AshRose, cursor: "pointer" }}
              onClick={() => {
                setShowModal(true);
              }}
            >
              Choose a parent
            </span>{" "}
            to proceed, or{" "}
            <Link
              className="underline"
              to={Paths.RegisterParent}
              style={{ color: Colors.AshRose }}
            >
              register
            </Link>{" "}
            one if you haven't.
          </div>
        </div>
      ) : (
        <div className="w-full">
          <SelectedParents
            selectedParents={selectedParents}
            onParentsChange={() => {
              setShowModal(true);
            }}
          />
        </div>
      )}
      <ParentsListModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        onParentsSelect={(value) => dispatch(setSelectedParents(value))}
      />
    </div>
  );
};

export default StudentAdmissionFormStepOne;
